.wrap { position: relative; display: inline-flex; }
.trigger { display: inline-flex; align-items: center; }
.icon { width: 12px; height: 12px; flex-shrink: 0; }
.bubble {
  position: absolute; z-index: 70; top: calc(100% + 8px); left: 50%; transform: translateX(-50%);
  width: 250px; padding: 10px 12px;
  background: #1f2430; color: #fff; border-radius: 8px;
  font-size: 11px; font-weight: 400; line-height: 16px; text-align: left;
  box-shadow: 0 10px 28px rgba(0,0,0,.24);
}
.bubble::before {
  content: ''; position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%);
  border: 5px solid transparent; border-bottom-color: #1f2430;
}
.formula { display: block; margin-top: 6px; color: #b9c2d0; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 10px; }
